import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AgentEditPage } from "@/features/agent-inventory/edit/agent-edit-page";

export const Route = createFileRoute("/agent-inventory/$agentId/edit")({
  component: () => (
    <PermissionGuard module="agent_inventory" action="edit">
      <AgentEditPage />
    </PermissionGuard>
  ),
});
